export const MessageIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="31"
            fill="none"
        >
            <path
                stroke="#F0730C"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10.667 12.916h.013m5.32 0h.013m5.32 0h.014M12 20.666H6.667C5.194 20.666 4 19.509 4 18.083V7.749c0-1.426 1.194-2.583 2.667-2.583h18.666C26.806 5.166 28 6.323 28 7.749v10.334c0 1.426-1.194 2.583-2.667 2.583h-6.666L12 27.124v-6.458Z"
            />
        </svg>
    );
};
